import { baseApi as api } from "./baseApi";
var injectedRtkApi = api.injectEndpoints({
    endpoints: function (build) { return ({
        getAsset: build.query({
            query: function (queryArg) { return ({
                url: "/accounts/".concat(queryArg.accountId, "/trial_containers/").concat(queryArg.trialContainerId, "/assets/").concat(queryArg.assetId),
            }); },
        }),
        getAssetChapters: build.query({
            query: function (queryArg) { return ({
                url: "/accounts/".concat(queryArg.accountId, "/trial_containers/").concat(queryArg.trialContainerId, "/assets/").concat(queryArg.assetId, "/chapters"),
            }); },
        }),
        updateAssetChapters: build.mutation({
            query: function (queryArg) { return ({
                url: "/accounts/".concat(queryArg.accountId, "/trial_containers/").concat(queryArg.trialContainerId, "/assets/").concat(queryArg.assetId, "/chapters"),
                method: "POST",
                body: queryArg.body,
            }); },
        }),
        exportFormPdf: build.query({
            query: function (queryArg) { return ({
                url: "/accounts/".concat(queryArg.accountId, "/trial_containers/").concat(queryArg.trialContainerId, "/forms/").concat(queryArg.formId, "/exports"),
            }); },
        }),
        getFormHistory: build.query({
            query: function (queryArg) { return ({
                url: "/accounts/".concat(queryArg.accountId, "/trial_containers/").concat(queryArg.trialContainerId, "/forms/").concat(queryArg.formId, "/history"),
            }); },
        }),
        completeFormTransition: build.mutation({
            query: function (queryArg) { return ({
                url: "/accounts/".concat(queryArg.accountId, "/trial_containers/").concat(queryArg.trialContainerId, "/forms/").concat(queryArg.formId, "/transitions/").concat(queryArg.transitionId),
                method: "POST",
            }); },
        }),
        getFormVersions: build.query({
            query: function (queryArg) { return ({
                url: "/accounts/".concat(queryArg.accountId, "/trial_containers/").concat(queryArg.trialContainerId, "/forms/").concat(queryArg.formId, "/versions"),
            }); },
        }),
        getFormVersion: build.query({
            query: function (queryArg) { return ({
                url: "/accounts/".concat(queryArg.accountId, "/trial_containers/").concat(queryArg.trialContainerId, "/forms/").concat(queryArg.formId, "/versions/").concat(queryArg.versionNumber),
            }); },
        }),
        getForms: build.query({
            query: function (queryArg) { return ({
                url: "/accounts/".concat(queryArg.accountId, "/trial_containers/").concat(queryArg.trialContainerId, "/forms"),
                params: {
                    form_container_id: queryArg.formContainerId,
                    form_container_type: queryArg.formContainerType,
                },
            }); },
        }),
        createForm: build.mutation({
            query: function (queryArg) { return ({
                url: "/accounts/".concat(queryArg.accountId, "/trial_containers/").concat(queryArg.trialContainerId, "/forms"),
                method: "POST",
                body: queryArg.body,
            }); },
        }),
        getForm: build.query({
            query: function (queryArg) { return ({
                url: "/accounts/".concat(queryArg.accountId, "/trial_containers/").concat(queryArg.trialContainerId, "/forms/").concat(queryArg.formId),
            }); },
        }),
        getTrialContainer: build.query({
            query: function (queryArg) { return ({
                url: "/accounts/".concat(queryArg.accountId, "/trial_containers/").concat(queryArg.trialContainerId),
            }); },
        }),
    }); },
    overrideExisting: false,
});
export { injectedRtkApi as trialContainersApi };
export var useGetAssetQuery = injectedRtkApi.useGetAssetQuery, useGetAssetChaptersQuery = injectedRtkApi.useGetAssetChaptersQuery, useUpdateAssetChaptersMutation = injectedRtkApi.useUpdateAssetChaptersMutation, useExportFormPdfQuery = injectedRtkApi.useExportFormPdfQuery, useGetFormHistoryQuery = injectedRtkApi.useGetFormHistoryQuery, useCompleteFormTransitionMutation = injectedRtkApi.useCompleteFormTransitionMutation, useGetFormVersionsQuery = injectedRtkApi.useGetFormVersionsQuery, useGetFormVersionQuery = injectedRtkApi.useGetFormVersionQuery, useGetFormsQuery = injectedRtkApi.useGetFormsQuery, useCreateFormMutation = injectedRtkApi.useCreateFormMutation, useGetFormQuery = injectedRtkApi.useGetFormQuery, useGetTrialContainerQuery = injectedRtkApi.useGetTrialContainerQuery;
